import { get } from 'lodash';
import { toast } from 'react-toastify';

export const alertError = (error) => {
  const errorMsg = get(error, 'message');

  if (errorMsg) {
    toast.error(`Error: ${errorMsg}`, {
      position: toast.POSITION.TOP_RIGHT,
    });
    console.error(errorMsg);
  }
};

export const alertSuccess = (message) => {
  toast.success(message, {
    position: toast.POSITION.TOP_RIGHT,
  });
};
